/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class CustomerApi {
    static getInstance() {
        if (!this.instance) this.instance = new CustomerApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 删除客户
    async delCustomer (id){
        let url = `/api/customer/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    //************************************************* */ 

    // 获取客户列表头-新
    async getCustomerList (param, page_num, page_size){
        let url = `/api/customer/entity/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 查询客户地址  列表行-新
    async getAddressList(param){
        let url = `/api/customer/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增客户-新 （保存用户基本信息+地址）
    async addCustomer (param){
        let url = `/api/customer/entity/save/address`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增地址-新 (只保存地址信息)
    async addAddress(param){
        let url = `/api/customer`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑客户信息-新 (只保存客户基本信息)
    async editCustomer(param){
        let url = `/api/customer/entity/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑地址-新 (只保存地址信息)
    async editAddress(param,id){
        let url = `/api/customer/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 编辑经销商子级ERP Code
    async saveSubERPCode(param){
        let url = `/api/customer/save/sub/code`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 删除地址-新
    async deleteAddress(id){
        let url = `/api/customer/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 新增/编辑location
    async saveLocation(param){
        let url = `/api/dealer/location/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增PickUpLocation
    async savePickUpLocation(param){
        let url = `/api/dealer/pickup/point/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    async invalidPickUpLocation(id){
        let url = `/api/dealer/pickup/point/invalid/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // location列表
    async getLocationList(param){
        let url = `/api/dealer/location/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // pick up列表
    async getPickUpLocationList(param){
        let url = `/api/dealer/pickup/point/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 删除子级ERP Code
    async deleteSubERPCode(id){
        let url = `/api/customer/${id}/clear/sub/code`
        let result = await this.getData(url,{},'GET')
        return result
    }

    //************************************************* */ 

    // 同步ERP客户信息
    async syncERPCustomer(){
        let url = `/api/system/source/synchronize`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取国家下拉配置
    async getCountry(param){
        // let url = `/api/system/dictionary/country`
        let url = `/api/system/country/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存查阅客户详细信息记录
    async sensitive(param){
        let url = `/api/system/sensitive`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取订单来源
    async getOrderSource (param){
        // let url = `/api/system/source`
        // let result = await this.getData(url,param,'GET')
        // return result

        let url = `/api/system/source/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取默认地址
    async getDefaultAddress (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

}

export {
    CustomerApi
}